import React, { Component } from 'react';
import Exam from './exam';

class ExamContainer extends Component {
    render() {
        return (
            <article className="exam-container d-flex flex-row justify-content-center position-relative scroll-wrapper">
                {/* <ExamText examHalfClass={this.props.examHalfClass} /> */}
                <div className="exam-line"></div>
                <Exam onSheetSelect={this.props.onSheetSelect} examHalfClass={this.props.examHalfClass} examCheckClass={this.props.examCheckClass} onExamChecked={this.props.onExamChecked} examMemoClass={this.props.examMemoClass} onExamMemo={this.props.onExamMemo} />
            </article>
        );
    }
}

export default ExamContainer;